

































/* eslint-disable prettier/prettier */
import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '../../store/module-names'

import { AppGetterNames } from '../../store/modules/app/keys'

import { CashFlowCalculator } from '@/constants/cash-flow'
import moment from 'moment-timezone'
import { toCurrency } from '../../store/utils/converter'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'

type ComponentData = {
  errorMessage: string
  initialLoading: boolean
  reloading: boolean
}

export default Vue.extend({
  name: 'CashFlowSummary',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    cashFlowCalculator: {
      type: CashFlowCalculator,
      required: true,
    },
    siteStats: {
      type: Array,
      default: () => [],
    },
    activeRealSites: {
      type: Array,
      default: () => [],
    },
    monthlyCostsData: {
      type: Array,
      default: () => [],
    },
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      default: moment().valueOf(),
    },
  },

  data(): ComponentData {
    return {
      errorMessage: '', // TODO ERROR MESSAGE
      initialLoading: true,
      reloading: false,

      // cashFlowCalculator: null,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
      isCareTeamUser: AppGetterNames.isCareTeamUser,
      // isNursingHomeUser: AppGetterNames.isNursingHomeUser
    }),
    hasRevenueData(): boolean {
      // 'config' contains the revenue stats...
      return this.activeRealSites.some(s => s?.siteUsageStats?.config != null)
    },

    numberOfActiveRealHomes(): number {
      return this.activeRealSites.length
    },
    numberOfModems(): number {
      return this.activeRealSites.reduce((prev, cur) => prev + (cur.siteUsageStats?.gateways || 0), 0)
    },
    stripRevenue(): number {
      return this.cashFlowCalculator?.getTotalRevenue(false, true, false) || 0
      // return this.activeRealSites.reduce((prev, cur) => prev + (calcStripRevenue(cur.siteUsageStats) || 0), 0)
    },
    oneTimeRevenue(): number {
      // GW sales and install fees
      let r = this.cashFlowCalculator?.getTotalRevenue(false, false, true) || 0
      // console.log('got one time revenue total: ', r, this.cashFlowCalculator?.siteCashFlowStats)
      return r
      // return this.activeRealSites.reduce((prev, cur) => prev + (calcOneTimeRevenuesPerMonth(cur.siteUsageStats) || 0), 0)
    },
    monthlyRevenue(): number {
      return this.cashFlowCalculator?.getTotalRevenue(true, false, false) || 0
    },
    totalRevenue(): number {
      return this.cashFlowCalculator?.getTotalRevenue() || 0
      // return this.oneTimeRevenue + this.monthlyRevenue + this.stripRevenue
    },
    oneTimeCost(): number {
      return this.cashFlowCalculator?.getTotalExpenses(false, true, true) || 0
    },
    opexCost(): number {
      return this.cashFlowCalculator?.getTotalExpenses(true, true, false) || 0
    },
    capexCost(): number {
      return this.cashFlowCalculator?.getTotalExpenses(false, false, true) || 0
    },
    // monthlyCost(): number {
    //   return this.activeRealSites.reduce(
    //     // hacky solution for now. We don't know which GWs are for glucometer or vitals... so this will work so long as we keep vitals and glucometer on separate sites.
    //     (prev, cur) =>
    //       prev + Math.max(calcTotalEmrCost(cur.siteUsageStats) || 0, calcTotalEmrCost(cur.siteUsageStats) || 0),
    //     0
    //   )
    // },
    emrCost(): number {
      return this.cashFlowCalculator?.getTotalExpenses(true, false, false) || 0
    },
    totalCost(): number {
      return this.cashFlowCalculator?.getTotalExpenses() || 0
    },
    totalProfit(): number {
      // eslint-disable-next-line prettier/prettier
      return this.totalRevenue - this.totalCost
    },
  },
  async mounted(): Promise<void> {
    // this.cashFlowCalculator = new CashFlowCalculator(
    //     this.siteStats,
    //     this.monthlyCostsData,
    //     this.startTimestamp,
    //     this.endTimestamp
    // )
  },
  methods: {
    toCurrency,
  },
})
